<template>
    <component :is="iconComponent" :name="icon" />
</template>
<script setup>
import { defineAsyncComponent, defineProps } from 'vue';

const props = defineProps({
    icon: String
});

let iconComponent = defineAsyncComponent(() =>
    import(`../assets/icons/${props.icon}.svg`)
);
</script>
